export default __webpack_public_path__ + "static/media/avatar.f1f7a488.jpg";